import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

if (environment.ambiente == 'prod') {
  enableProdMode();
}
console.log("%cMain-1", "color: red");
platformBrowserDynamic().bootstrapModule(AppModule);
console.log("%cMain-2", "color: red");



// WEBPACK FOOTER //
// ./src/main.ts